import axiosHttp from "./interceptor.service";

const postForm = (data) => {
  return axiosHttp.post("/feedback/createForm", data);
};

const getForm = (data) => {
  return axiosHttp.get("/feedback/getForm", {
    params: {
      sort: data?.sort,
      limit: data?.limit,
      search: data?.search,
      page: data?.page,
    },
  });
};

const updateForm = (id, data) => {
  return axiosHttp.put(`/feedback/updateForm/${id}`, data);
};

const deleteForm = (id) => {
  return axiosHttp.delete(`/feedback/deleteForm/${id}`);
};

export { postForm, getForm, updateForm, deleteForm };
